import React, { useState, useMemo } from 'react';
import PageTable from '../PageList/pageTable';
import { UUID } from '../../redux/models';
import { ParsedComponentDeep } from '../../helpers';
import { BodyClusterModalFooterButtons } from './bodyClusterModalFooterButtons';
import { Input, Icon } from 'antd';
import './styles/bodyClusterModal.style.scss';

export interface BodyModalProps {
  components: ParsedComponentDeep[];
  columns: any;
  selectedKeys?: UUID[];
  onSubmit: (selectedKeys: UUID[]) => void;
  onCancel: () => void;
  hasClusterName?: boolean;
  loading?: boolean;
  clusterId?: string;
}

const BodyClusterModal: React.FC<BodyModalProps> = ({
  components,
  columns,
  selectedKeys,
  hasClusterName,
  onSubmit,
  onCancel,
  loading,
  clusterId,
  ...props
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<UUID[]>(selectedKeys ?? []);
  const [searchTerm, setSearchTerm] = useState('');

  const onSelectChange = (newSelectedRowKeys: UUID[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  };

  const verifyDisabled = !selectedRowKeys?.length || !hasClusterName;
  const filteredComponents = useMemo(() => {
    const characteristic = components?.filter(component => component?.category !== 'Indicator');
    if (searchTerm) {
      return characteristic?.filter(component => component?.name?.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    return characteristic;
  }, [components, searchTerm]);

  return (
    <div className='body-cluster-modal'>
      <Input
        prefix={<Icon type='search' style={{ color: '#707374' }} />}
        placeholder='Search'
        onChange={event => setSearchTerm(event.target.value)}
        data-testid='input-search-characteristic'
      />
      <PageTable
        size='default'
        loadingFunc={loading}
        data={filteredComponents}
        columns={columns}
        rowSelection={rowSelection}
        pagination={3}
        rowKey='id'
        {...props}
      />
      <BodyClusterModalFooterButtons
        onSubmit={() => onSubmit(selectedRowKeys)}
        onCancel={onCancel}
        isDisabled={verifyDisabled}
        clusterId={clusterId}
      />
    </div>
  );
};

export default BodyClusterModal;
